import { createGetSectionsTree } from './sections.tsx';
import { createHigherLevelViewHook } from './utils.tsx';

export const useSectionsTree = createHigherLevelViewHook(createGetSectionsTree);
